import React from 'react';
import styled from '@emotion/styled';

import { CHAT_CARD_LAYOUT } from '../../aisdk';
import { useAiPanelLayout } from '../Concierge/AiPanelLayoutContext';

const ShellContentGridRoot = styled.div<{ $aiTrackPx: number }>`
  display: grid;
  flex: 1;
  min-width: 0;
  min-height: 0;
  align-items: stretch;
  box-sizing: border-box;
  grid-template-columns: minmax(0, 1fr) ${({ $aiTrackPx }) => $aiTrackPx}px;
  transition: grid-template-columns ${CHAT_CARD_LAYOUT.transitionDurationMs}ms
    ${CHAT_CARD_LAYOUT.transitionEasing};
`;

export interface ShellContentGridProps {
  sidePanelWidth: number;
  children: React.ReactNode;
}

/**
 * Rovo / Jira-style shell: CSS grid with a dedicated main track and optional right rail.
 * Registers the grid node on layout context so `AiPanelSlot` can size the AI column to the
 * viewport (works inside `z-unified-nav-v2` shadow DOM).
 */
export function ShellContentGrid({
  sidePanelWidth,
  children,
}: ShellContentGridProps) {
  const layout = useAiPanelLayout();

  return (
    <ShellContentGridRoot
      ref={layout?.setShellGridNode}
      $aiTrackPx={sidePanelWidth}
      data-unified-nav-shell-grid
    >
      {children}
    </ShellContentGridRoot>
  );
}
